import React, {useEffect, useState} from "react";
import ContentLoader from "react-content-loader";
import {useWindowSize} from "../../Utility/hooks";

const AvatarLoader = (props) => {
  const {width} = useWindowSize();

  const [dimensions, setDimensions] = useState({width: 70, height: 55})

  useEffect(() => {
    if (width > 1200) {
      setDimensions({width: 120, height: 85});
    } else if (width < 500) {
      setDimensions({width: 60, height: 45});
    } else {
      setDimensions({width: 70, height: 55});
    }
  }, [width]);

  return (
    <ContentLoader
      speed={2}
      width={dimensions.width}
      height={dimensions.height}
      viewBox="0 0 70 55"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <circle cx="33" cy="28" r="26"/>
    </ContentLoader>
  )
};

export default AvatarLoader;
